module.exports = __webpack_public_path__ + "img/report-icon-active.9316e075.svg";